<template>
    <div class="mobile-form-container">
        <div class="mobile-form">
            <h2 class="form-title">联通大数据-智慧任务审核</h2>
            <el-form ref="form" :model="form" label-width="120px">
                <el-form-item label="任务名称">
                    <el-input v-model="form.task_name" :readonly="true"></el-input>
                </el-form-item>
                <el-form-item label="城市名">
                    <el-input v-model="form.city_name" :readonly="true"></el-input>
                </el-form-item>
                <el-form-item label="用户名称">
                    <el-input v-model="form.author" :readonly="true"></el-input>
                </el-form-item>
                <el-form-item label="围栏数据时间">
                    <el-input v-model="form.citymonth" :readonly="true"></el-input>
                </el-form-item>
                <el-form-item v-if="form.status == 0">
                    <el-button type="primary" @click="auditTask(1)">通过</el-button>
                    <el-button @click="auditTask(2)">拒绝</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
  
<script>
import { getdatasbyid, updatedatas } from '../../api/unicomData'
export default {
    data() {
        return {
            form: {
            }
        };
    },
    methods: {
        auditTask(type) {
            updatedatas({ id: this.form.id, status: type }).then((res) => {
                if (res.errno === 0) {
                    this.$message.success('操作成功！')
                    this.getTaskData(this.form.id)
                }
                else {
                    this.$message.error('操作失败,请重试！')
                }
            })

        },
        getTaskData(task) {
            getdatasbyid({ id: task }).then((res) => {
                if (res.errno === 0) {
                    this.form = res.data
                }
                else {
                    this.$message.error(res.error)
                }
            })
        }
    },
    created() {
        const id = this.$route.query.id;
        if (id) {
            this.getTaskData(id)
        }
        else {
            let queryId = localStorage.getItem('queryId')
            this.getTaskData(queryId)
        }
    }
};
</script>
  
<style scoped>
/* 在这里添加移动端适配的样式 */
.mobile-form-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
}

.mobile-form {
    padding: 10px;
    width: 100%;
    max-width: 500px;
}

.el-form-item {
    margin-bottom: 10px;
}

.form-title {
    text-align: center;
    margin-bottom: 20px;
}

/* 适配移动端视图 */
@media (max-width: 768px) {
    .el-form-item label {
        float: none;
        width: auto;
        text-align: left;
        padding-right: 0;
    }

    .el-form-item .el-form-item__content {
        margin-left: 0;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/unicomData/audits.vue